/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PoolsContractV2,
  PoolsContractV2Interface,
} from "../PoolsContractV2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_soilToken",
        type: "address",
      },
      {
        internalType: "contract ProtocolSettings",
        name: "_protocolSettings",
        type: "address",
      },
      {
        internalType: "address",
        name: "_validator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AddressZero",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "destinationChainSelector",
        type: "uint64",
      },
    ],
    name: "DestinationChainNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ExceedsLockedAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "HardCapExceeded",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientContractBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPositionId",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidToken",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "currentBalance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "calculatedFees",
        type: "uint256",
      },
    ],
    name: "NotEnoughBalance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "NotEnoughBalanceForRewards",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyAdminCanCall",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolClosed",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolIsNotShort",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolIsShort",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolNotExists",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "RewardsExceededLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "RewardsHolderDisagreement",
    type: "error",
  },
  {
    inputs: [],
    name: "SoilRewardsNotSupported",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "sourceChainSelector",
        type: "uint64",
      },
    ],
    name: "SourceChainNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "UnlockingNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAmount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rewardsHolder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isRewardsHolder",
        type: "bool",
      },
    ],
    name: "AgreementOnBeingRewardsHolderChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewards",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "soilRewards",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "ClaimRewards",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isShort",
        type: "bool",
      },
    ],
    name: "CreatePool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "messageId",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "destinationChain",
        type: "uint64",
      },
      {
        indexed: true,
        internalType: "uint64",
        name: "sourceChain",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fees",
        type: "uint256",
      },
    ],
    name: "CrossChainTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "FundsWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newPoolsContractFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "PoolsContractFeeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "Redeposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SoilLimitChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rewardsHolder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOfRewards",
        type: "uint256",
      },
    ],
    name: "SoilRewardsSend",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokenLimitChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "rewardsHolder",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountOfRewards",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TokenRewardsSend",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "unlockTime",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TokensUnlocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
    ],
    name: "UpdatePool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "fromLevel",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "toLevel",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UpgradeToPoolWithHigherYield",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "agreesToTransferRewards",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_allowed",
        type: "bool",
      },
    ],
    name: "allowlistToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "allowlistedTokens",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "amountOfSoilRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "amountOfTokenRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "changeAgreementToBeRewardsHolder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_poolsContractFee",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "changePoolsContractFeeForToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newLimit",
        type: "uint256",
      },
    ],
    name: "changeSoilRewardsLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_newLimit",
        type: "uint256",
      },
    ],
    name: "changeTokenRewardsLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_poolId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "_level",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rewards",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_soilRewards",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_endTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_softCap",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_hardCap",
        type: "uint256",
      },
      {
        internalType: "uint16[]",
        name: "_fixedAPRs",
        type: "uint16[]",
      },
      {
        internalType: "bool",
        name: "_isShort",
        type: "bool",
      },
    ],
    name: "createPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "userAddress",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "poolId",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct PoolsContractSharedStructs.DepositParams",
        name: "_params",
        type: "tuple",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "feeBalanceInToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
    ],
    name: "getPoolInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "poolId",
            type: "uint16",
          },
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "softCap",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "hardCap",
            type: "uint256",
          },
          {
            internalType: "uint16[]",
            name: "fixedAPRs",
            type: "uint16[]",
          },
          {
            internalType: "bool",
            name: "isShort",
            type: "bool",
          },
        ],
        internalType: "struct PoolsContractV2.PoolInfo",
        name: "requestedPoolInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getUnlockedTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "unlockTime",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
    ],
    name: "getUserPoolBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "limitOfSoilRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "limitOfTokenRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "poolBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "poolInfo",
    outputs: [
      {
        internalType: "uint16",
        name: "poolId",
        type: "uint16",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "softCap",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hardCap",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isShort",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolsContractFeeInToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "protocolSettings",
    outputs: [
      {
        internalType: "contract ProtocolSettings",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_poolId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "_level",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rewards",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_claimSignature",
        type: "bytes",
      },
    ],
    name: "redeposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "sendSoilRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "sendTokenRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_soilToken",
        type: "address",
      },
    ],
    name: "setSoilToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "soilToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "userAddress",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "poolId",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "unlockSignature",
            type: "bytes",
          },
        ],
        internalType: "struct PoolsContractSharedStructs.UnlockTokenParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "unlockTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_poolId",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_endTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_hardCap",
        type: "uint256",
      },
    ],
    name: "updatePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_userAddress",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_poolId",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "_level",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_upgradeToLevel",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_rewards",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_soilRewards",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_deadline",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_claimSignature",
        type: "bytes",
      },
    ],
    name: "upgradeToPoolWithHigherYield",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "userInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastDepositTime",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "validator",
    outputs: [
      {
        internalType: "contract PoolsValidator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "userAddress",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "poolId",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewards",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "soilRewards",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "withdrawSignature",
            type: "bytes",
          },
        ],
        internalType: "struct PoolsContractSharedStructs.WithdrawParams",
        name: "_params",
        type: "tuple",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "withdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "withdrawFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "userAddress",
            type: "address",
          },
          {
            internalType: "uint16",
            name: "poolId",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "rewards",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "soilRewards",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "withdrawSignature",
            type: "bytes",
          },
        ],
        internalType: "struct PoolsContractSharedStructs.WithdrawParams",
        name: "withdrawParams",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "withdrawUnlockedTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PoolsContractV2__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _soilToken: string,
    _protocolSettings: string,
    _validator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PoolsContractV2> {
    return super.deploy(
      _soilToken,
      _protocolSettings,
      _validator,
      overrides || {}
    ) as Promise<PoolsContractV2>;
  }
  getDeployTransaction(
    _soilToken: string,
    _protocolSettings: string,
    _validator: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _soilToken,
      _protocolSettings,
      _validator,
      overrides || {}
    );
  }
  attach(address: string): PoolsContractV2 {
    return super.attach(address) as PoolsContractV2;
  }
  connect(signer: Signer): PoolsContractV2__factory {
    return super.connect(signer) as PoolsContractV2__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PoolsContractV2Interface {
    return new utils.Interface(_abi) as PoolsContractV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PoolsContractV2 {
    return new Contract(address, _abi, signerOrProvider) as PoolsContractV2;
  }
}
